import type { DropdownOption } from "@/components/common/Dropdown/Dropdown.types";
import GenPop from "@assets/icons/base/gen_pop.svg?react";
import Familiar from "@assets/icons/base/familiar.svg?react";
import Awareness from "@assets/icons/base/awareness.svg?react";

export const BASE_OPTIONS: DropdownOption[] = [
  {
    value: "GENPOP",
    label: "Gen Pop",
    icon: <GenPop className="h-[16px] w-[16px]" />,
  },
  {
    value: "FAMILIAR",
    label: "Familiar",
    icon: <Familiar className="h-[16px] w-[16px]" />,
  },
  {
    value: "ADRECALL",
    label: "Ad Recall",
    icon: <GenPop className="h-[16px] w-[16px]" />,
  },
  {
    value: "USER",
    label: "User",
    icon: <GenPop className="h-[16px] w-[16px]" />,
  },
  {
    value: "AWARE",
    label: "Aware",
    icon: <Awareness className="h-[18px] w-[18px]" />,
  },
];

export const PROFILE_BASE_OPTIONS: DropdownOption[] = [
  {
    id: 1,
    value: "GENERAL_POPULATION",
    label: "General Population",
    icon: <GenPop className="h-[18px] w-[18px]" />,
  },
  {
    id: 2,
    value: "AWARE_OF_BRAND",
    label: "Aware Of Brand",
    icon: <Familiar className="h-[18px] w-[18px]" />,
  },
  {
    id: 3,
    value: "FAMILIAR_WITH_BRAND",
    label: "Familiar With Brand",
    icon: <Awareness className="h-[18px] w-[18px]" />,
  },
  {
    id: 4,
    value: "TRIEND_BRAND",
    label: "Tried Brand",
    icon: <GenPop className="h-[18px] w-[18px]" />,
  },
  {
    id: 5,
    value: "USE_BRAND",
    label: "Use Brand",
    icon: <Familiar className="h-[18px] w-[18px]" />,
  },
  {
    id: 6,
    value: "RECOMMEND_BRAND",
    label: "Recommend Brand",
    icon: <Awareness className="h-[18px] w-[18px]" />,
  },
];
